import { Injectable } from "@angular/core";

import { map } from "rxjs/operators";

import { EndpointsConstants } from "./constants-v2";
import { Company, Customer, Jobsite, LegalEntityDTO } from "@cemex-core/types-v2";

import { HttpCemex } from "@cemex-core/angular-services-v8";

@Injectable()
export class FinancialDocuments {
  constructor(private http: HttpCemex, private endpoints: EndpointsConstants) {}

  public getLegalEntity(): Promise<LegalEntityDTO> {
    return this.http
      .get(this.getUrl("legalentity"))
      .pipe(
        map((response: any) => {
          const aux: LegalEntityDTO = response;
          return aux;
        })
      )
      .toPromise()
      .then((data) => data)
      .catch((error) => error);
  }

  public getAllLegalEntityCustomers(): Promise<Customer[]> {
    return this.http
      .get(this.getUrl("legalentitycustomers"))
      .pipe(
        map((response: any) => {
          const aux: LegalEntityDTO = response;
          const snapshot = aux.responseLegalEntity.customer;
          return snapshot;
        })
      )
      .toPromise()
      .then((data) => data)
      .catch((error) => error);
  }

  public getLegalEntityByCustomer(customerCode: any): Promise<Company[]> {
    return this.http
      .get(this.getUrl("legalentity?customerCode=" + customerCode))
      .pipe(
        map((response: any) => {
          const aux: LegalEntityDTO = response;
          const snapshot = aux.responseLegalEntity.company;
          return snapshot;
        })
      )
      .toPromise()
      .then((data) => data)
      .catch((error) => error);
  }

  public getLegalEntityByCompany(companyCode: any): Promise<Customer[]> {
    return this.http
      .get(this.getUrl("legalentity?companyCode=" + companyCode))
      .pipe(
        map((response: any) => {
          const aux: LegalEntityDTO = response;
          const snapshot = aux.responseLegalEntity.customer;
          return snapshot;
        })
      )
      .toPromise()
      .then((data) => data)
      .catch((error) => error);
  }

  public getLegalEntityJobsites(customerCode: any, companyCode: any): Promise<Jobsite[]> {
    const api = "legalentityjobsites?companyCode=" + companyCode + "&customerCode=" + customerCode;
    return this.http
      .get(this.getUrl(api))
      .pipe(
        map((response: any) => {
          const aux: LegalEntityDTO = response;
          const snapshot = aux.responseLegalEntity.jobSite;
          return snapshot;
        })
      )
      .toPromise()
      .then((data) => data)
      .catch((error) => error);
  }

  private getUrl(api: string): string {
    const url = this.endpoints.V1 + this.endpoints.armCapability + api;
    return url;
  }
}
